module.exports = __webpack_public_path__ + "static/media/kyte_logo.9888c7df.svg";